export const toggleButtonTheme = 
{
  colorScheme: {
    light: {
      root: {
        checkedColor: '{surface.0}'    
      },
      content: {
        checkedBackground: '{primary.color}'
      }
    }  
  },
}